import { linkCitationChunk } from './citationDisplay';
import { projectLevelDataroomPath } from './intelligenceSourceReadiness';

export function getLensCitationChunk(citation, chunks) {
    if (!citation) return null;
    const linked = linkCitationChunk(citation, chunks);
    if (linked) return linked;

    const preview = (citation.text_preview || citation.chunk || '').trim();
    if (preview) {
        return {
            ...citation,
            chunk: preview,
            chunk_topics: citation.chunk_topics,
            chunk_intent: citation.chunk_intent,
            chunk_doc_type: citation.chunk_doc_type,
        };
    }
    return null;
}

export function canOpenLensCitationPdf(citation, effectiveWorkstreamIds = []) {
    if (projectLevelDataroomPath(citation)) return true;
    if (!citation?.file_id) return false;
    return citation?.workstream_id != null || effectiveWorkstreamIds.length > 0;
}

export function findCitationByRef(citations, ref) {
    const raw = String(ref || '').trim();
    const bracketed = raw.match(/^\[?(\d+)\]?$/);
    const normalized = bracketed ? bracketed[1] : null;
    if (!normalized) return null;
    return (Array.isArray(citations) ? citations : []).find(c => {
        const r = String(c?.ref || '').replace(/[^\d]/g, '');
        return r === normalized;
    });
}
